module.exports = __webpack_public_path__ + "img/CRT_Spear-002.81e953c5.png";